import React from 'react';
import Lottie from 'lottie-react';
import { useNavigate } from 'react-router-dom';

import notFoundCatAnimation from 'assets/animations/not-found-cat.json';
import { Button } from 'components/ui/button';
import { useAuth } from 'contexts/AuthContext';

const NotFound: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  const handlePrimaryAction = () => {
    navigate(isAuthenticated ? '/home' : '/login');
  };

  const handleSecondaryAction = () => {
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }

    navigate('/');
  };

  return (
    <div className="mx-auto flex min-h-[70vh] w-full max-w-5xl flex-col items-center justify-center gap-6 px-4 py-6 text-center sm:px-6 sm:py-8 lg:gap-8 lg:px-8">
      <div className="relative flex w-full justify-center">
        <div
          data-testid="not-found-animation"
          className="w-full max-w-[28rem] sm:max-w-[32rem] lg:max-w-[36rem]"
        >
          <Lottie animationData={notFoundCatAnimation} autoplay loop className="h-full w-full" />
        </div>
      </div>

      <div className="flex max-w-2xl flex-col items-center gap-5">
        <div className="space-y-3">
          <p className="text-xs font-semibold uppercase tracking-[0.24em] text-foundation-calm-blue-700">
            404
          </p>
          <h1 className="text-3xl font-semibold tracking-tight text-foundation-base-darkbase-dark-500 sm:text-4xl">
            Page not found
          </h1>
          <p className="text-base leading-7 text-foundation-base-darkbase-dark-400 sm:text-lg">
            This cat wandered into a dead end before your page could load. The link may be outdated,
            or the address may have a typo.
          </p>
        </div>

        <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:justify-center">
          <Button
            size="auto"
            className="min-w-[12rem]"
            onClick={handlePrimaryAction}
          >
            {isAuthenticated ? 'Return to dashboard' : 'Go to login'}
          </Button>
          <Button
            variant="secondary"
            size="auto"
            className="min-w-[10rem]"
            onClick={handleSecondaryAction}
          >
            Go back
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
